import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const trendingDownPurple = svgToTinyDataUri(
  `<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="trending_down">
<mask id="mask0_0_46" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<rect id="Bounding box" width="32" height="32" fill="var(--fill-0, #D9D9D9)"/>
</mask>
<g mask="url(#mask0_0_46)">
<path id="trending_down_2" d="M21.3333 24V21.3333H24.8L17.8667 14.4667L12.5333 19.8L2.66667 9.86667L4.53333 8L12.5333 16L17.8667 10.6667L26.6667 19.4667V16H29.3333V24H21.3333Z" fill="var(--fill-0, #501283)"/>
</g>
</g>
</svg>`
);
